module.exports = __webpack_public_path__ + "static/media/defaultBusinessLogo.fe2a0b57.png";